const region = "us-east-1";

const dev = {

	appSettingsData: {
		BuyerCognitoGroup: "wl-dev-procurement-portal-buyers",
		SupplierCognitoGroup: "wl-dev-procurement-portal-suppliers",
		federatedIDPProvider: "wl-dev-procurement-portal-idp"
	},

	amplify_config: {

		Auth: {

			Cognito: {

				userPoolId: "us-east-1_2bgK8QTal",

				userPoolClientId: "2725vl7s55d8hqde7kcrkfdjdb",

				loginWith: {

					oauth: {

						domain: "wl-dev-procurement-portal.auth.us-east-1.amazoncognito.com",

						scopes: [],

						redirectSignIn: [
							"https://wl-dev-procurement-portal.com/login",
							"http://localhost:3000/login"
						],

						redirectSignOut: [
							"https://wl-dev-procurement-portal.com/login",
							"http://localhost:3000/login"
						],

						responseType: "code"

					}

				}

			}

		},

		API: {

			REST: {

				'print': {

					endpoint: "https://api.wl-dev-procurement-portal.com/print",

					region: region

				}

			}

		}

	}

};

export default dev;